let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8c0xi")).then(() => parcelRequire('a4Qzw'));